var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"guide"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleGuide.apply(null, arguments)}}},[_c('img',{staticClass:"guide",attrs:{"src":require("@/assets/guide.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }